import { addresssCustomerInfoIntialValue as CustomerInfo } from "../CustomerFormInitialValues";
import { CustomerDiscount } from "../Customer.types";

export const AFFILATION_REQUIRED = "Affilation is required";
export const MINIMUM_DISCOUNT =
  "Minimum Discount should not be more than 00.00 decimal places";

export const validateCustomerDiscountSetupFields = (
  customerDiscountInfo: CustomerDiscount
) => {
  let customerDiscountErrors = CustomerInfo.discount;
  let isValidated = true;
  let contractValue =
    customerDiscountInfo.contract.find(
      (x) => x.contractSelected === "CO-OP Pricing"
    )?.minimumDiscount || "";
  const minimumDiscountRegex = /^\d{1,2}(?:\.\d{1,2})?$/;
  if (customerDiscountInfo?.afilliationSelected.length < 1) {
    console.log("Test");   customerDiscountErrors.afilliationSelected = AFFILATION_REQUIRED;
    isValidated = false;
  } else {
    customerDiscountErrors.afilliationSelected = "";
  }  
  return { isValidated, customerDiscountErrors };
};
